// extracted by mini-css-extract-plugin
export default {"row":"TnMyWallet_row__sYeMM","wallet":"TnMyWallet_wallet__XQSVJ","wallet-ltr":"TnMyWallet_wallet-ltr__+Dpdc","button":"TnMyWallet_button__nAO6+"};